/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Text_To_Audio_Clear_AllInputs */

const en_dialog_text_to_audio_clear_all = /** @type {(inputs: Dialog_Text_To_Audio_Clear_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear all`)
};

const es_dialog_text_to_audio_clear_all = /** @type {(inputs: Dialog_Text_To_Audio_Clear_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar todo`)
};

/**
* | output |
* | --- |
* | "Clear all" |
*
* @param {Dialog_Text_To_Audio_Clear_AllInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_clear_all = /** @type {((inputs?: Dialog_Text_To_Audio_Clear_AllInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Clear_AllInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_clear_all(inputs)
	return en_dialog_text_to_audio_clear_all(inputs)
});